import HorizontalLineIcon from "../../images/default_devider_new_icon.svg";

export const customExtraBlock = (editor) => {
  editor.Components.addType("hr", {
    extend: "default",
    isComponent: (el) => {
      return (
        (el.type === "hr" || el.type === "HR") &&
        el.getAttribute("data-gjs-type") === "hr" &&
        el.getAttribute("data-gjs-name") === "hr"
      );
    },

    model: {
      defaults: {
        tagName: "div",
        removable: true,
        draggable: true,
        droppable: false,
        copyable: true,
        resizable: true,
        attributes: {
          'data-gjs-type': 'hr',
          'data-gjs-name': 'hr',
          class: 'hrclass',
        },

        style: {
          display: "block",
          height: "1px",
          width:"50%",
          marginTop: "16px",
          marginBottom: "16px",
          padding: "2px 0",
          background: "rgba(0, 0, 0, 0.1)",
        },
      },
    },
  });
  editor.Blocks.add("hr", {
    category: "extra",
    label: "Divider",
    media: `<img src="${HorizontalLineIcon}" class="horizontal-line-block" title="Horizontal Line" draggable="true" />`,
    
    content: {
      type: "hr",
    },
  });
};
